import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class VerifyNewPasswordGuard implements CanActivate{
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const userEmail = localStorage.getItem('UserEmail');
    const code = localStorage.getItem('Code');
    
    if(userEmail !== null && code === null){
      return true;
    }
    else{
      localStorage.clear();
      this.router.navigate(['/login']);
      return false;
    }
  }
};
